import { useUser } from '@myosh/myosh-login';
import { Link } from 'react-router-dom';

const Home = () => {
  const { state } = useUser();

  return (
    <div className="bg-gray-5 min-h-screen">
      <header className="bg-primary-1 text-mono-0 shadow">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold">myOSH Energy</h1>
          <p className="text-primary-4 mt-1 text-sm">
            Welcome, {state.user?.preferred_username}
          </p>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          <Link
            to="/energy-check"
            className="bg-mono-1 border-gray-4 hover:border-primary-3 group block rounded-lg border p-6 shadow transition hover:shadow-lg"
          >
            <div className="mb-3 text-4xl">⚡</div>
            <h2 className="text-primary-1 group-hover:text-primary-2 mb-2 text-xl font-semibold">
              Energy Check
            </h2>
            <p className="text-gray-2 text-sm">
              Identify energy hazards, answer quick questions, and get an
              instant risk rating with suggested controls.
            </p>
          </Link>

          <div className="bg-mono-1 border-gray-4 rounded-lg border-2 border-dashed p-6 text-center">
            <div className="text-gray-3 mb-3 text-4xl">📊</div>
            <h2 className="text-gray-2 mb-2 text-xl font-semibold">Reports</h2>
            <p className="text-gray-3 text-sm">Coming soon...</p>
          </div>

          <div className="bg-mono-1 border-gray-4 rounded-lg border-2 border-dashed p-6 text-center">
            <div className="text-gray-3 mb-3 text-4xl">📋</div>
            <h2 className="text-gray-2 mb-2 text-xl font-semibold">History</h2>
            <p className="text-gray-3 text-sm">Coming soon...</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
